import axios from '../config.js';
const resource = '/user';

export default {
  /**
   * Authenticates the user
   * @param {String} username 
   * @param {String} password 
   */
  login(username, password) {
    return axios.post(`${resource}/login`, {
      username: username,
      password: password,
      session_key: localStorage.getItem('login_session_key')
    }); 
  },

  mslogin () {
    return axios.post(`/ms/login`, {
      type: 'api',
      base_url: window.location.origin,
      session_key: localStorage.getItem('login_session_key')
    });
  },

  msProcessResponse (body) {
    return axios.post(`/ms/login/validate`, body);
  },

  /**
   * Gets the user info
   * @param {Number} id User ID
   */
  get(id) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    return axios.get(`${resource}/${id}`);
  },
  // MANY OTHER ENDPOINT RELATED STUFFS

  updatePatient(id='', payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    return axios.put(`${resource}/${id}`, payload);
  },

  getDoctors(per_page=null, { search='', } = {}) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    const params = new URLSearchParams();
    
    if (search)
      params.append('search', search)
    if (per_page)  params.append('per_page', per_page);
    return axios.get(`${resource}?doctors_only`, { params: params });
  },

  getAgents(per_page=null, { search='', }  = {}) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    const params = new URLSearchParams();
    
    if (search)
      params.append('search', search)
    if (per_page)  params.append('per_page', per_page);
    return axios.get(`${resource}?tma_only`, { params: params });
  },

  getUsers(page=null, per_page=null, tma_and_doctors_only=null) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    axios.defaults.headers.common['Content-Type'] = 'multipart/form-data'
    
    const params = new URLSearchParams();
    if (tma_and_doctors_only)  params.append('tma_and_doctors_only', tma_and_doctors_only);
    if (per_page)  params.append('per_page', per_page);
    return axios.get(`${resource}?page=${page}`, { params: params });
  },
  updateUser(id='', payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    var data = {
      _method: 'PUT',
      ...payload
    }
    return axios.put(`${resource}/${id}`, data)
  },
  createUser(payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    return axios.post(resource, payload);
  },
  deleteUser(id) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    return axios.delete(`${resource}/${id}`);
  },
  search(payload) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
      return axios.get(resource, payload);
  },
  createUser2(payload) {
    /**
     * USE CREATE USER THIS IS FOR TESTING
     */
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    return axios.post(`${resource}/qweqwe`, payload);
  },
  getUserDoctors(payload) {
    if (payload.params) {
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(payload.params)) {
        params.append(key, value);
      }
  
      payload.params = params;
    }

    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;

    return axios.get(`${resource}`, payload);
  },
  fetch(params) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;
    return axios.get(`${resource}`, { params });
  },
  resetUserPasswordViaEmail(email) {
    return axios.post('/password/reset', { email });
  }
};